import React from 'react';
import { Helmet } from 'react-helmet-async';
import LinkInterceptor from '../components/LinkInterceptor';
import '../styles/HomePage.css';

const HomePage: React.FC = () => {
  console.log('[DEBUG HomePage] Rendering with SEO Helmet tags');

  return (
    <div className="home-page">
      <Helmet>
        <title>SpitFire Braai Catering | Home - Our Story &amp; Services</title>
        <meta name="description" content="Discover SpitFire Braai Catering — slow-braai'd succulent meats, smokey flavours, and professional on-site catering for your next event. Serving South Africa." />
        <meta property="og:title" content="SpitFire Braai Catering | Our Story &amp; Services" />
        <meta property="og:description" content="Slow-braai'd succulent meats and professional on-site catering for your next event." />
        <meta property="og:url" content="https://www.spitfirebraai.co.za/home" />
        <link rel="canonical" href="https://www.spitfirebraai.co.za/home" />
      </Helmet>
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Welcome to SpitFire</h1>
            <p className="hero-description">Waar ons feesVUUR!</p>
            <div className="cta-container">
              <LinkInterceptor to="/contact" className="cta-button">Say Hi</LinkInterceptor>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="section-title">Taste the goodness</h2>
          <div className="features-grid">
            <div className="feature-card">
              <img src="/graphics/Illustration 1 light.png" alt="Slow-braai'd succulent meats with smokey flavours" className="feature-image" />
              <h3>Spit-Braai'd Perfection</h3>
              <p>We slow-braai succulent meats, creating mouthwatering dishes with smokey flavours and fall-off-the-bone tenderness.</p>
            </div>
            <div className="feature-card">
              <img src="/graphics/Illustration 2 dark.png" alt="Professional on-site braai catering for events" className="feature-image" />
              <h3>On-Site Catering</h3>
              <p>We bring the entire cooking experience to your venue, creating a spectacular centrepiece for your event.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ready for a sizzling feast?</h2>
          <p>Check out our mouthwatering gallery, read customer reviews, or contact us to book your next event!</p>
          <div className="cta-buttons">
            <LinkInterceptor to="/contact" className="secondary-button">Contact us</LinkInterceptor>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;